<!--

@@author        j0Shi
@@date          2019.06.25
@@desc          Displays the various possible status messages
                during pricerequests on the object page
@@usedby        ObjectVavancyForm -> Object

-->

<template>
  <div class="vacancy-status">
    <bootstrap-bubble-element
      v-if="error"
      v-bind="{
        orientation: 'bottom-left',
        type: 'danger'
      }"
    >
      {{ $t('object:vacancy.widget.notAvailableObject') }}
    </bootstrap-bubble-element>
    <bootstrap-bubble-element
      v-if="isFetchingPrice && !error"
      v-bind="{
        orientation: 'bottom-left',
        type: 'info'
      }"
    >
      {{ $t('object:vacancy.widget.requestPending') }}
    </bootstrap-bubble-element>
    <bootstrap-bubble-element
      v-if="isDateSelected && price && !isFetchingPrice && !error"
      v-bind="{
        orientation: 'bottom-left',
        type: 'success',
      }"
    >
      <i class="icon">
        <icon-check-alternative-two />
      </i>
      <div class="text">
        {{ $t('object:vacancy.widget.availablePeriod') }}
      </div>
    </bootstrap-bubble-element>
    <bootstrap-bubble-element
      v-if="(!isDateSelected || price === null) && !isFetchingPrice && !error"
      v-bind="{
        orientation: 'bottom-left',
      }"
    >
      <i class="icon">
        <icon-calendar-alt />
      </i>
      <div class="text">
        {{ $t('object:vacancy.widget.pleaseChoosePeriod') }}
      </div>
    </bootstrap-bubble-element>
    <bootstrap-bubble-element
      v-if="isDateSelected && price === false && !isFetchingPrice && !error"
      v-bind="{
        orientation: 'bottom-left',
        type: 'danger',
      }"
    >
      <i class="icon">
        <icon-times />
      </i>
      <div class="text">
        {{ $t('object:vacancy.widget.occupiedPeriod') }}
      </div>
    </bootstrap-bubble-element>
    <bootstrap-bubble-element
      v-if="0"
      v-bind="{
        orientation: 'bottom-left',
        type: 'info',
      }"
    >
      <div class="text">
        {{ $t('object:vacancy.widget.differentPeriod') }}
      </div>
    </bootstrap-bubble-element>
  </div>
</template>

<script>
import BootstrapBubbleElement from 'components/BootstrapBubbleElement.vue';

import IconCheckAlternativeTwo from 'ICON:IconCheckAlternativeTwo';
import IconCalendarAlt from 'ICON:IconCalendarAlt';
import IconTimes from 'ICON:IconTimes';

export default {
  name: 'ObjectVacancyFormStatus',
  components: {
    BootstrapBubbleElement,
    IconCheckAlternativeTwo,
    IconCalendarAlt,
    IconTimes,
  },
  i18nOptions: { namespaces: ['object'] },
  props: {
    isDateSelected: {
      type: Boolean,
      default: false,
    },
    price: {
      type: [Number, Boolean],
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isFetchingPrice() {
      return this.$store.getters.getIsFetchingPrice;
    },
  },
};
</script>

<style lang="scss" scoped>
.vacancy-status {
  margin: 0 -1px;
  transform: translate(0, -1px);
  position: relative;

  .bubble {
    overflow: hidden;
    border-top-left-radius: $radius_card;
    border-top-right-radius: $radius_card;
    margin: -$margin_content (-$margin_content) $margin_content;
    padding: $half_margin_content $margin_content;
    display: flex;
    align-items: center;
    background: $color_grey_bg;
    color: var(--color_text);

    @include font_size_s;

    line-height: 1.2em;

    &.bubble-success {
      background: $color_success_500;
      color: #fff;

      @include font_bold;
    }

    &.bubble-info {
      background: $color_info_500;
      color: #fff;

      @include font_bold;
    }

    &.bubble-danger {
      background: $color_danger_300;
      color: #fff;

      @include font_bold;
    }

    .icon {
      @include font_size_xl;

      margin: 0 0.5em 0 0;
      line-height: 1em;
    }
  }
}

</style>
